import React, { useState } from 'react';
import CodeBlock from './highlighter';
import { useSnackbar } from 'notistack';

const CodeGenerator = () => {
    // Stavy pro vstupy
    const [cargoWeight, setCargoWeight] = useState(false);
    const [cockpitName, setCockpitName] = useState('Cockpit');
    const [generatedCode, setGeneratedCode] = useState('');
    const [displayIndexCargo, setDisplayIndexCargo] = useState(0);
    const [BgColorCargo, setBgColorCargo] = useState('');
    const [ColorCargo, setColorCargo] = useState('');
    const [CargoFontSize, setCargoFontSize] = useState(0);
    const [CargoAlarm, setCargoAlarm] = useState(false);
    const [CargoAlarmDisplay, setCargoAlarmDisplay] = useState(false);
    const [CargoAlarmSound, setCargoAlarmSound] = useState(false);
    const [CargoStopDrills, setCargoStopDrills] = useState(false);
    const [EnergyStatus, setEnergyStatus] = useState(false);
    const [displayIndexEnergy, setDisplayIndexEnergy] = useState(0);
    const [EnergyStatusLow, setEnergyStatusLow] = useState(false);
    const [EnergyStatusLowAlarm, setEnergyStatusLowAlarm] = useState(false);
    const [EnergyStatusLowDisplay, setEnergyStatusLowDisplay] = useState(false);
    const [EnergyFontSize, setEnergyFontSize] = useState(0);
    const [ColorEnergy, setColorEnergy] = useState('');
    const [BgColorEnergy, setBgColorEnergy] = useState('');
    const [WeaponStatus, setWeaponStatus] = useState(false);
    const [WeaponStatusMain, setWeaponStatusMain] = useState(false);
    const [WeaponStatusGroup, setWeaponStatusGroup] = useState(false);
    const [WeaponStatusGroupFont, setWeaponStatusGroupFont] = useState(0);
    const [displayIndexWeaponGroup, setdisplayIndexWeaponGroup] = useState(0);
    const [displayIndexWeaponMain, setdisplayIndexWeaponMain] = useState(0);
    const [WeaponStatusMainFont, setWeaponStatusMainFont] = useState(0);
    const [Parking, setParking] = useState(false);
    const [ParkingRecharge, setParkingRecharge] = useState(false);
    const [ParkingLights, setParkingLights] = useState(false);
    const [ParkingEngine, setParkingEngine] = useState(false);
    const [ConnectorName, setConnectorName] = useState('Connector');

    const { enqueueSnackbar } = useSnackbar();

    const hasDuplicates = (...values) => {
        const filteredValues = values.filter(v => v !== null && v !== undefined);
        const uniqueSet = new Set(filteredValues);
        return uniqueSet.size !== filteredValues.length;
    };

    const handleGenerate = (e) => {
        e.preventDefault();
        if (hasDuplicates(
            cargoWeight ? displayIndexCargo : null,
            WeaponStatusGroup ? displayIndexWeaponGroup : null,
            WeaponStatusMain ? displayIndexWeaponMain : null,
            EnergyStatus ? displayIndexEnergy : null
        )) {
            setGeneratedCode('')
            enqueueSnackbar('Two or more functions are trying to be displayed on one screen. Check your screen settings!', { variant: 'error', autoHideDuration: 10000 });
            return;
        }

        const cargo = `void Cargo(IMyCockpit cockpit)
{
    var cargoContainers = new List<IMyCargoContainer>();
    GridTerminalSystem.GetBlocksOfType(cargoContainers);
    double totalCurrentVolume = 0;
    double totalMaxVolume = 0;
    
    foreach (var container in cargoContainers)
    {
        var inventory = container.GetInventory();
        totalCurrentVolume += (double)inventory.CurrentVolume;
        totalMaxVolume += (double)inventory.MaxVolume;
    }
    double percentage = (totalCurrentVolume / totalMaxVolume) * 100;
    string displayText = $"\\n• Cargo Capacity •\\n" +
        $"{totalCurrentVolume:0.000}/{totalMaxVolume:0.000} L\\n" +
        $"{percentage:0.0} %";
    var lcdcargo = cockpit.GetSurface(${displayIndexCargo});
    if (lcdcargo != null)
    {
        lcdcargo.ContentType = ContentType.TEXT_AND_IMAGE;
        lcdcargo.FontSize = ${(CargoFontSize ? CargoFontSize.replace(",",".") : "2.0")}f;
        lcdcargo.Alignment = TextAlignment.CENTER;
        lcdcargo.FontColor = Color.${(ColorCargo ? ColorCargo : "White")};
        lcdcargo.BackgroundColor = Color.${(BgColorCargo ? BgColorCargo : "Black")};
        ${(CargoAlarm ? `if (percentage >= 100)
        {
               ${(CargoAlarmDisplay ? `lcdcargo.FontColor = Color.White;
               lcdcargo.BackgroundColor = Color.Red;` : "")}
               ${(CargoAlarmSound ? `SoundAlert(cockpit, "Alarm Block");` : "")}
               ${(CargoStopDrills ? `var drills = new List<IMyShipDrill>();
               GridTerminalSystem.GetBlocksOfType(drills);
               foreach (var drill in drills)
               {
                   drill.Enabled = false;
               }` : "")}
        }` : "")}
        lcdcargo.WriteText(displayText);
    }
}`

        const code = `public Program()
{
    Runtime.UpdateFrequency = UpdateFrequency.Update100;
}
public void Main(string argument, UpdateType updateSource)
{
    
    IMyCockpit cockpit = GridTerminalSystem.GetBlockWithName("${(cockpitName ? cockpitName : "Cockpit")}") as IMyCockpit;
    if (cockpit == null)
    {
        Echo("Cockpit named \'${(cockpitName ? cockpitName : "Cockpit")}\' not found. Check your cockpit name!");
        return;
    }
    ${(cargoWeight ? "Cargo(cockpit);" : "")}
    ${(EnergyStatus ? "DisplayEnergyStatus(cockpit);" : "")}
    

    ${(WeaponStatusMain && WeaponStatus ? `IMyTextSurface cannonSurface = cockpit.GetSurface(${(displayIndexWeaponMain ? displayIndexWeaponMain : 0)});
    IMyTerminalBlock cannon = GridTerminalSystem.GetBlockWithName("Main Weapon");
    if (cannon == null)
    {
        Echo("Cannon named 'Main Weapon' not found!");
        return;
    }` : "")}
    ${(WeaponStatus && WeaponStatusGroup ? `IMyTextSurface weaponSurface = cockpit.GetSurface(${(displayIndexWeaponGroup ? displayIndexWeaponGroup : 0)});
    IMyBlockGroup weaponGroup = GridTerminalSystem.GetBlockGroupWithName("Weapons");
    if (weaponGroup == null)
    {
        Echo("Group 'Weapons' not found! Create a group with this name and add weapons to it.");
        return;
    }
    var weapons = new List<IMyTerminalBlock>();
    weaponGroup.GetBlocks(weapons, block => block.HasInventory);
    DisplayWeaponStatuses(weaponSurface, weapons);` : "")}
    ${(WeaponStatusMain && WeaponStatus ? "WeaponStatus(cannonSurface, cannon);" : "")}
    ${(Parking ? "ToggleSystemsBasedOnConnector();" : "")}
}
${(Parking ? `public void ToggleSystemsBasedOnConnector()
{
    IMyShipConnector connector = GridTerminalSystem.GetBlockWithName("${ConnectorName}") as IMyShipConnector;
    if (connector == null)
    {
        Echo("Connector not found!");
        return;
    }
    ${(ParkingEngine ? `List<IMyThrust> thrusters = new List<IMyThrust>();
    GridTerminalSystem.GetBlocksOfType<IMyThrust>(thrusters);` : "")}
    ${(ParkingLights ? `List<IMyLightingBlock> lights = new List<IMyLightingBlock>();
    GridTerminalSystem.GetBlocksOfType<IMyLightingBlock>(lights);` : "")}
    ${(ParkingRecharge ? `List<IMyBatteryBlock> batteries = new List<IMyBatteryBlock>();
    GridTerminalSystem.GetBlocksOfType<IMyBatteryBlock>(batteries);` : "")}
    if (connector.Status == MyShipConnectorStatus.Connected)
    {
        ${(ParkingEngine ? `foreach (IMyThrust thruster in thrusters)
        {
            thruster.Enabled = false;
        }` : "")}
        ${(ParkingLights ? `foreach (IMyLightingBlock light in lights)
        {
            light.Enabled = false;
        }` : "")}
        ${(ParkingRecharge ? `foreach (IMyBatteryBlock battery in batteries)
        {
            battery.ChargeMode = ChargeMode.Recharge;
        }` : "")}
    }
    else
    {
        ${(ParkingEngine ? `foreach (IMyThrust thruster in thrusters)
        {
            thruster.Enabled = true;
        }` : "")}
        ${(ParkingLights ? `foreach (IMyLightingBlock light in lights)
        {
            light.Enabled = true;
        }` : "")}
        ${(ParkingRecharge ? `foreach (IMyBatteryBlock battery in batteries)
        {
            battery.ChargeMode = ChargeMode.Auto;
        }` : "")}
    }
}` : "")}
${(WeaponStatus && WeaponStatusGroup ? `void DisplayWeaponStatuses(IMyTextSurface weapongdisplay, List<IMyTerminalBlock> weapons)
{
    weapongdisplay.ContentType = ContentType.TEXT_AND_IMAGE;
    weapongdisplay.Alignment = TextAlignment.CENTER;
    weapongdisplay.FontSize = ${(WeaponStatusGroupFont ? WeaponStatusGroupFont.replace(",",".") : "2.0")}f;
    int allAmmo = 0;
    foreach (var weapon in weapons)
    {
        int ammoCount = 0;
        for (int i = 0; i < weapon.InventoryCount; i++)
        {
            IMyInventory inv = weapon.GetInventory(i);
            List<MyInventoryItem> items = new List<MyInventoryItem>();
            inv.GetItems(items);
            foreach (var item in items)
            {
                if (item.Type.TypeId == "MyObjectBuilder_AmmoMagazine")
                {
                    ammoCount += (int)item.Amount;
                }
            }
        }
        weapongdisplay.BackgroundColor = Color.Black;
        weapongdisplay.FontColor = Color.Red;
        if (allAmmo < 20)
        {
            weapongdisplay.FontColor = Color.White;
            weapongdisplay.BackgroundColor = Color.Red;
        }
        allAmmo = allAmmo + ammoCount;
    }
    weapongdisplay.WriteText("Ammo\\n" + allAmmo, false);
}` : "")}
${(cargoWeight ? cargo : "")}
${(WeaponStatusMain && WeaponStatus ? `void WeaponStatus(IMyTextSurface lcdWeapon, IMyTerminalBlock cannon)
{
    lcdWeapon.ContentType = ContentType.TEXT_AND_IMAGE;
    lcdWeapon.Alignment = TextAlignment.CENTER;    
    int ammoCount = 0;    
    int inventoryCount = cannon.InventoryCount;
    for (int i = 0; i < inventoryCount; i++)
    {
        IMyInventory inv = cannon.GetInventory(i);
        List<MyInventoryItem> items = new List<MyInventoryItem>();
        inv.GetItems(items);
        
        foreach (var item in items)
        {
            if (item.Type.TypeId == "MyObjectBuilder_AmmoMagazine")
            {
                ammoCount += (int)item.Amount;
            }
        }
    }
    string status;
    if (!cannon.IsWorking)
        {
            status = "OFFLINE";
            lcdWeapon.FontColor = Color.Red;
            lcdWeapon.BackgroundColor = Color.Black;
        }
    else if (ammoCount <= 0)
        {
            status = "NO AMMO";
            lcdWeapon.FontColor = Color.White;
            lcdWeapon.BackgroundColor = Color.Red;
        }
    else
        {
            status = "READY";
            lcdWeapon.FontColor = Color.White;
            lcdWeapon.BackgroundColor = Color.Black;
        }
    
    string text = $"\\nAmmo: {ammoCount}\\n{status}";
    lcdWeapon.FontSize = ${(WeaponStatusMainFont ? WeaponStatusMainFont.replace(",",".") : "3.0")}f;
    lcdWeapon.WriteText(text, false);
}` : "")}
${(EnergyStatus ? `void DisplayEnergyStatus(IMyCockpit cockpit)
{
        var batteries = new List<IMyBatteryBlock>();
        GridTerminalSystem.GetBlocksOfType(batteries);            
        if (batteries.Count == 0)
        {
            Echo("The vehicle has no batteries!");
            return;
        }
        double currentEnergy = 0;
        double maxEnergy = 0;
    
        foreach (var battery in batteries)
        {
            currentEnergy += battery.CurrentStoredPower;
            maxEnergy += battery.MaxStoredPower;
        }
        double energyPercentage = (currentEnergy / maxEnergy) * 100;
        string energyText = $"\\n• Energy Status •\\n" +
                        $"{currentEnergy:0.00} / {maxEnergy:0.00} MWh\\n" +
                        $"{energyPercentage:0.0}%";
        var lcdenergy = cockpit.GetSurface(${displayIndexEnergy});
        if (lcdenergy != null)
        {
            lcdenergy.ContentType = ContentType.TEXT_AND_IMAGE;
            lcdenergy.FontSize = ${(EnergyFontSize ? EnergyFontSize.replace(",",".") : "2.0")}f;
            lcdenergy.Alignment = TextAlignment.CENTER;
            lcdenergy.WriteText(energyText);
            lcdenergy.FontColor = Color.${(ColorEnergy ? ColorEnergy : "White")};
            lcdenergy.BackgroundColor = Color.${(BgColorEnergy ? BgColorEnergy : "Black")};
            ${(EnergyStatusLow ? `if (energyPercentage < 25)
            {
                ${(EnergyStatusLowDisplay ? `lcdenergy.BackgroundColor = Color.Red;
                lcdenergy.FontColor = Color.White;` : "")}
                ${(EnergyStatusLowAlarm ? `SoundAlert(cockpit, "Alarm Block");` : "")}
            }` : "")}
        }
}` : "")}
${((CargoAlarmSound && CargoAlarm && cargoWeight) || (EnergyStatus && EnergyStatusLowAlarm && EnergyStatusLow) ? `void SoundAlert(IMyCockpit cockpit, string soundBlockName)
{
    var soundBlock = GridTerminalSystem.GetBlockWithName(soundBlockName) as IMySoundBlock;
    if (soundBlock != null)
    {
        soundBlock.Play();
    }
    else
    {
        Echo("Sound block named \'Alarm Block\' not found. Check your Sound Block name!");
    }
}` : "")}`;

        setGeneratedCode(code);

        enqueueSnackbar('Successfully generated!', { variant: 'success' });
    };

    return (
        <div className="container mt-4">
            <form className="frm" onSubmit={handleGenerate}>

                <div className="form-group mt-3">
                    <label htmlFor="cockpitName">What is the name of your cockpit?</label>
                    <input
                        type="text"
                        className="form-control"
                        id="cockpitName"
                        placeholder="Zadejte název kokpitu"
                        value={(cockpitName ? cockpitName : "Cockpit")}
                        onChange={(e) => setCockpitName(e.target.value)}
                    />
                </div>

                <div className="form-group mt-3">
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="cargoWeight"
                            checked={cargoWeight}
                            onChange={(e) => setCargoWeight(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="cargoWeight">
                            <i class="bi bi-toggles"></i> Cargo weight
                        </label>
                    </div>
                </div>

                {cargoWeight && (
                    <div className="box">
                        <div className="form-group mt-3">
                            <label htmlFor="displayName">Which screen do you want to display it on?</label>
                            <select
                                id="displayName"
                                className="form-control"
                                onChange={(e) => setDisplayIndexCargo(e.target.value)}>
                                <option value="0">Central</option>
                                <option value="1">Left</option>
                                <option value="2">Right</option>
                                <option value="3">Bottom</option>
                                <option value="4">Additional display 1</option>
                                <option value="5">Additional display 2</option>
                            </select>
                        </div>
                        <div className="form-group mt-3">
                            <label htmlFor="bgcolorcargo">Background color</label>
                            <select
                                id="bgcolorcargo"
                                className="form-control"
                                onChange={(e) => setBgColorCargo(e.target.value)}>
                                <option value="Black">Black</option>
                                <option value="White">White</option>
                                <option value="Red">Red</option>
                                <option value="Green">Green</option>
                                <option value="Blue">Blue</option>
                                <option value="Yellow">Yellow</option>
                                <option value="Orange">Orange</option>
                                <option value="Purple">Purple</option>
                                <option value="Cyan">Cyan</option>
                                <option value="Gray">Gray</option>
                            </select>
                        </div>
                        <div className="form-group mt-3">
                            <label htmlFor="bgcolorcargo">Text color</label>
                            <select
                                id="bgcolorcargo"
                                className="form-control"
                                onChange={(e) => setColorCargo(e.target.value)}>
                                <option value="White">White</option>
                                <option value="Black">Black</option>
                                <option value="Red">Red</option>
                                <option value="Green">Green</option>
                                <option value="Blue">Blue</option>
                                <option value="Yellow">Yellow</option>
                                <option value="Orange">Orange</option>
                                <option value="Purple">Purple</option>
                                <option value="Cyan">Cyan</option>
                                <option value="Gray">Gray</option>
                            </select>
                        </div>
                        <label htmlFor="cargoFontSize">How large a font will be displayed?</label>
                        <input
                            type="number"
                            step="0.1"
                            min="0.1"
                            className="form-control"
                            id="cargoFontSize"
                            placeholder="Zadejte název kokpitu"
                            value={(CargoFontSize ? CargoFontSize : "2.0")}
                            onChange={(e) => setCargoFontSize(e.target.value)}
                        />
                        <div className="form-group mt-3">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="cargoAlarm"
                                    checked={CargoAlarm}
                                    onChange={(e) => setCargoAlarm(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="cargoAlarm">
                                    <i class="bi bi-toggles"></i> Notify when full?
                                </label>
                            </div>
                        </div>
                        {CargoAlarm && (
                            <>
                                <div className="form-group mt-3">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="CargoAlarmDisplay"
                                            checked={CargoAlarmDisplay}
                                            onChange={(e) => setCargoAlarmDisplay(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="CargoAlarmDisplay">
                                            <i class="bi bi-toggles"></i> Color the display?
                                        </label>
                                    </div>
                                </div>
                                <div className="form-group mt-3">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="CargoAlarmSound"
                                            checked={CargoAlarmSound}
                                            onChange={(e) => setCargoAlarmSound(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="CargoAlarmSound">
                                            <i class="bi bi-toggles"></i> Sound the alarm?
                                        </label>
                                    </div>
                                    {(CargoAlarmSound && (
                                        <span className="text-danger">Name the Sound Block "Alarm Block"</span>
                                    ))}
                                </div>
                                <div className="form-group mt-3">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="CargoStopDrills"
                                            checked={CargoStopDrills}
                                            onChange={(e) => setCargoStopDrills(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="CargoStopDrills">
                                            <i class="bi bi-toggles"></i> Stop drills when filled?
                                        </label>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}
                <div className="form-group mt-3">
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="EnergyStatus"
                            checked={EnergyStatus}
                            onChange={(e) => setEnergyStatus(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="EnergyStatus">
                            <i class="bi bi-toggles"></i> Energy status
                        </label>
                    </div>
                </div>
                {EnergyStatus && (
                    <div className="box">
                        <div className="form-group mt-3">
                            <label htmlFor="displayIndexEnergy">Which screen do you want to display this on?</label>
                            <select
                                id="displayIndexEnergy"
                                className="form-control"
                                onChange={(e) => setDisplayIndexEnergy(e.target.value)}>
                                <option value="0">Central</option>
                                <option value="1">Left</option>
                                <option value="2">Right</option>
                                <option value="3">Bottom</option>
                                <option value="4">Additional display 1</option>
                                <option value="5">Additional display 2</option>
                            </select>
                        </div>
                        <div className="form-group mt-3">
                            <label htmlFor="BgColorEnergy">Background color</label>
                            <select
                                id="BgColorEnergy"
                                className="form-control"
                                onChange={(e) => setBgColorEnergy(e.target.value)}>
                                <option value="Black">Black</option>
                                <option value="White">White</option>
                                <option value="Red">Red</option>
                                <option value="Green">Green</option>
                                <option value="Blue">Blue</option>
                                <option value="Yellow">Yellow</option>
                                <option value="Orange">Orange</option>
                                <option value="Purple">Purple</option>
                                <option value="Cyan">Cyan</option>
                                <option value="Gray">Gray</option>
                            </select>
                        </div>
                        <div className="form-group mt-3">
                            <label htmlFor="ColorEnergy">Text color</label>
                            <select
                                id="ColorEnergy"
                                className="form-control"
                                onChange={(e) => setColorEnergy(e.target.value)}>
                                <option value="White">White</option>
                                <option value="Black">Black</option>
                                <option value="Red">Red</option>
                                <option value="Green">Green</option>
                                <option value="Blue">Blue</option>
                                <option value="Yellow">Yellow</option>
                                <option value="Orange">Orange</option>
                                <option value="Purple">Purple</option>
                                <option value="Cyan">Cyan</option>
                                <option value="Gray">Gray</option>
                            </select>
                        </div>
                        <label htmlFor="EnergyFontSize">How large a font will be displayed?</label>
                        <input
                            type="number"
                            step="0.1"
                            min="0.1"
                            className="form-control"
                            id="EnergyFontSize"
                            placeholder="Zadejte název kokpitu"
                            value={(EnergyFontSize ? EnergyFontSize : "2.0")}
                            onChange={(e) => setEnergyFontSize(e.target.value)}
                        />
                        <div className="form-group mt-3">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="EnergyStatusLow"
                                    checked={EnergyStatusLow}
                                    onChange={(e) => setEnergyStatusLow(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="EnergyStatusLow">
                                    <i class="bi bi-toggles"></i> Alert for low status?
                                </label>
                            </div>
                        </div>
                        {EnergyStatusLow && (
                            <>
                                <div className="form-group mt-3">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="EnergyStatusLowAlarm"
                                            checked={EnergyStatusLowAlarm}
                                            onChange={(e) => setEnergyStatusLowAlarm(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="EnergyStatusLowAlarm">
                                            <i class="bi bi-toggles"></i> Sound the alarm?
                                        </label>
                                    </div>
                                    {(EnergyStatusLowAlarm && (
                                        <span className="text-danger">Name the Sound Block "Alarm Block"</span>
                                    ))}
                                </div>
                                <div className="form-group mt-3">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="EnergyStatusLowDisplay"
                                            checked={EnergyStatusLowDisplay}
                                            onChange={(e) => setEnergyStatusLowDisplay(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="EnergyStatusLowDisplay">
                                            <i class="bi bi-toggles"></i> Warning on the display?
                                        </label>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}
                <div className="form-group mt-3">
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="WeaponStatus"
                            checked={WeaponStatus}
                            onChange={(e) => setWeaponStatus(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="WeaponStatus">
                            <i class="bi bi-toggles"></i> Status of weapons
                        </label>
                    </div>
                </div>
                {(WeaponStatus && (
                    <>
                        <div className="form-group mt-3">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="WeaponStatusMain"
                                    checked={WeaponStatusMain}
                                    onChange={(e) => setWeaponStatusMain(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="WeaponStatusMain">
                                    <i class="bi bi-toggles"></i> Main weapon
                                </label>
                            </div>
                            {(WeaponStatusMain && (
                                <span className="text-danger">Name the main weapon "Main Weapon"</span>
                            ))}
                        </div>
                        {WeaponStatusMain && (
                            <div className="box">
                                <div className="form-group mt-3">
                                    <label htmlFor="displayIndexWeaponMain">Which screen do you want to display this
                                        on?</label>
                                    <select
                                        id="displayIndexWeaponMain"
                                        className="form-control"
                                        onChange={(e) => setdisplayIndexWeaponMain(e.target.value)}>
                                        <option value="0">Central</option>
                                        <option value="1">Left</option>
                                        <option value="2">Right</option>
                                        <option value="3">Bottom</option>
                                        <option value="4">Additional display 1</option>
                                        <option value="5">Additional display 2</option>
                                    </select>
                                </div>
                                <label htmlFor="WeaponStatusMainFont">How large a font will be displayed?</label>
                                <input
                                    type="number"
                                    step="0.1"
                                    min="0.1"
                                    className="form-control"
                                    id="WeaponStatusMainFont"
                                    placeholder="Zadejte název kokpitu"
                                    value={(WeaponStatusMainFont ? WeaponStatusMainFont : "2.0")}
                                    onChange={(e) => setWeaponStatusMainFont(e.target.value)}
                                />
                            </div>
                        )}
                        <div className="form-group mt-3">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="WeaponStatusGroup"
                                    checked={WeaponStatusGroup}
                                    onChange={(e) => setWeaponStatusGroup(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="WeaponStatusGroup">
                                    <i class="bi bi-toggles"></i> Weapons group
                                </label>
                            </div>
                            {(WeaponStatusGroup && (
                                <span className="text-danger">Name the weapon group "Weapons"</span>
                            ))}
                        </div>
                        {WeaponStatusGroup && (
                            <div className="box">
                                <div className="form-group mt-3">
                                    <label htmlFor="displayIndexWeaponGroup">Which screen do you want to display this
                                        on?</label>
                                    <select
                                        id="displayIndexWeaponGroup"
                                        className="form-control"
                                        onChange={(e) => setdisplayIndexWeaponGroup(e.target.value)}>
                                        <option value="0">Central</option>
                                        <option value="1">Left</option>
                                        <option value="2">Right</option>
                                        <option value="3">Bottom</option>
                                        <option value="4">Additional display 1</option>
                                        <option value="5">Additional display 2</option>
                                    </select>
                                </div>
                                <label htmlFor="WeaponStatusGroupFont">How large a font will be displayed?</label>
                                <input
                                    type="number"
                                    step="0.1"
                                    min="0.1"
                                    className="form-control"
                                    id="WeaponStatusGroupFont"
                                    placeholder="Zadejte název kokpitu"
                                    value={(WeaponStatusGroupFont ? WeaponStatusGroupFont : "2.0")}
                                    onChange={(e) => setWeaponStatusGroupFont(e.target.value)}
                                />
                            </div>
                        )}
                    </>
                ))}
                <div className="form-group mt-3">
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="Parking"
                            checked={Parking}
                            onChange={(e) => setParking(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="Parking">
                            <i class="bi bi-toggles"></i> Parking
                        </label>
                    </div>
                </div>
                {Parking && (
                    <div className="box">
                        <span
                            className="text-danger">This feature only works if the vehicle is connected via <b>Connector</b></span>
                        <div className="form-group mt-3">
                            <label htmlFor="ConnectorName">Connector name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="ConnectorName"
                                placeholder="Zadejte název kokpitu"
                                value={(ConnectorName ? ConnectorName : "Connector")}
                                onChange={(e) => setConnectorName(e.target.value)}
                            />
                        </div>
                        <div className="form-group mt-3">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="ParkingRecharge"
                                    checked={ParkingRecharge}
                                    onChange={(e) => setParkingRecharge(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="ParkingRecharge">
                                    <i class="bi bi-toggles"></i> Auto-recharge battery
                                </label>
                            </div>
                        </div>
                        <div className="form-group mt-3">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="ParkingLights"
                                    checked={ParkingLights}
                                    onChange={(e) => setParkingLights(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="ParkingLights">
                                    <i class="bi bi-toggles"></i> Autolights on/off
                                </label>
                            </div>
                        </div>
                        <div className="form-group mt-3">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="ParkingEngine"
                                    checked={ParkingEngine}
                                    onChange={(e) => setParkingEngine(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="ParkingEngine">
                                    <i class="bi bi-toggles"></i> Thrusters off/start
                                </label>
                            </div>
                        </div>
                    </div>
                )}
                <button type="submit" className="btn btn-primary mt-4">
                    <i class="bi bi-braces"></i> Generate code
                </button>
            </form>

            {generatedCode && (
                <div className="mt-4">
                    <h3>Generated code</h3>
                    <div className="alert alert-light text-center">Insert the code into the Programmable Block.
                        Everything is set, you don't have to do anything further.
                    </div>
                    <CodeBlock codeString={generatedCode} language="csharp"/>
                </div>
            )}
        </div>
    );
};

export default CodeGenerator;
